import {
    Component,
    effect,
    ElementRef,
    inject,
    Input,
    input
} from "@angular/core";
import { SERIE_REPOSITORY } from "@app/app.providers";
import { SharedDsnModule } from "@app/shared/modules/shared-dsn.module";
import { SharedMaterialModule } from "@app/shared/modules/shared-material.module";
import { CalcMemoryKatex } from "@app/shared/services/calc-memory-katex.service";
import { CalcMemory } from "@app/shared/services/calc-memory.service";
import { KatexAdapter } from "@app/shared/services/katex-adapter.service";
import { SerieEntity } from "@arch/domain/entity";
import { VisualizationEntity } from "@arch/domain/entity/visualization.entity";

@Component({
    selector: "app-about-visualization",
    imports: [SharedMaterialModule, SharedDsnModule],

    templateUrl: "./about-visualization.component.html",
    styleUrl: "./about-visualization.component.scss"
})
export class AboutVisualizationComponent {
    visualization = input<VisualizationEntity>();
    @Input({ required: false }) pdf: boolean;

    private readonly KatexAdapter = new KatexAdapter();
    private readonly CalcMemory = new CalcMemory();
    private readonly calcMemoryKatex = new CalcMemoryKatex({
        KatexAdapter: this.KatexAdapter,
        CalcMemory: this.CalcMemory
    });
    private readonly serieMapRepository = inject(SERIE_REPOSITORY);

    private elementRef = inject(ElementRef);

    public series: SerieEntity[] = [];

    constructor() {
        effect(() => {
            if (!this.visualization()) return;
            this.series = this.serieMapRepository.getByIds(
                this.visualization().props.series
            );
            setTimeout(() => {
                for (let $index = 0; $index < this.series.length; $index++) {
                    const serieSelected = this.series[$index];
                    const elementDOM =
                        this.elementRef?.nativeElement.querySelector(
                            `#Formula-${$index}`
                        );
                    if (elementDOM) {
                        this.calcMemoryKatex.setGeneralFormula({
                            serieSelected,
                            element: elementDOM as HTMLElement
                        });
                    }
                }
            }, 1000);
        });
    }
}
